import { render, staticRenderFns } from "./supplier.vue?vue&type=template&id=eb5854ec&scoped=true&"
import script from "./supplier.vue?vue&type=script&lang=js&"
export * from "./supplier.vue?vue&type=script&lang=js&"
import style0 from "./supplier.vue?vue&type=style&index=0&id=eb5854ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5854ec",
  null
  
)

export default component.exports